import React from 'react';
import classNames from 'classnames';
import { LEARN_TYPES } from 'constants/config';
import { Card } from 'ui';
import Text from 'components/shared/Text';
import CertificationBadge from 'components/CertificationBadge';
import CoverImage from '../CardCoverImage';
import DueDateBadge from './DueDateBadge';
import Progress from './Progress';
import Status from './Status';
import EstimatedDuration from './EstimatedDuration';

const COVER_WIDTH = 222;
const COVER_HEIGHT = 125;

const LearnContentCard = ({
  description,
  badge,
  counts,
  image,
  links,
  progress,
  title,
  type,
  isCompleted,
  onClick,
  estimatedMinutesToComplete,
}) => (
  <Card
    cap={progress.completedDate || image ? null : 'top'}
    onClick={onClick}
    stacked={type === LEARN_TYPES.PATH}
    url={links.view}
    className={classNames('LearnContentCard', {
      'LearnContentCard--hasDueDate': progress.dueDate,
      'LearnContentCard--hasImage': image,
      'LearnContentCard--path': type === LEARN_TYPES.PATH,
      'LearnContentCard--lesson': type === LEARN_TYPES.LESSON,
      'LearnContentCard--completed': isCompleted,
    })}
  >
    {(progress.dueDate || progress.completedDate) && (
      <DueDateBadge progress={progress} />
    )}
    {image && (
      <CoverImage image={image} width={COVER_WIDTH} height={COVER_HEIGHT} />
    )}
    <Card.Content padding="medium" className="LearnContentCard-content">
      <Text lines={image ? 3 : 4} className="LearnContentCard-title ws-pr">
        {title}
      </Text>
      {description && (
        <Text lines={image ? 3 : 6} className="LearnContentCard-description">
          {description}
        </Text>
      )}
      <div className="LearnContentCard-footer fd-r jc-sb">
        <div className="d-f fd-c jc-e">
          {type === LEARN_TYPES.PATH && <Progress {...counts} {...progress} />}
          {estimatedMinutesToComplete && (
            <EstimatedDuration
              estimatedMinutesToComplete={estimatedMinutesToComplete}
            />
          )}
          <Status type={type} progress={progress} />
        </div>
        {!!badge && (
          <div className="d-f ai-fe">
            <CertificationBadge
              height={36}
              width={29}
              foregroundColor={badge.foregroundColor}
              backgroundColor={badge.backgroundColor}
              iconName={badge.iconName}
              image={badge.image}
            />
          </div>
        )}
      </div>
    </Card.Content>
  </Card>
);

export default LearnContentCard;
